import commonGame from '../../commonGame';
import ConfirmationPanel from './ConfirmationPanel';
import common from '../../common';

const _hide = Symbol('_hide');

export default class TrashConfirmationPanel extends ConfirmationPanel {
	constructor() {
		super();
		// Attributes.
		this._canvasContainer = null;
		this._trashBgSprite = null;
		this._trashFgSprite = null;
	}

	init() {
		super.init();
		this._messageText.y += 20;
		const panelConfig = common.levelConfig.menu_panel;

		// Trash bg sprite.
		this._trashBgSprite = new PIXI.Sprite(P3.assets.texture('icon_replay_bg'));
		this._trashBgSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._trashBgSprite.y = this._messageText.y - 125 + (panelConfig.top_bar.position.y * 0.4);
		this._messageSprite.addChild(this._trashBgSprite);

		// Canvas container.
		this._canvasContainer = new PIXI.Container();
		this._canvasContainer.anchor = new PIXI.Point(0.5, 0.5);
		this._canvasContainer.scale = new PIXI.Point(0.11, 0.11);
		this._canvasContainer.y = this._messageText.y - 250;
		this._canvasContainer.rotation = Math.PI * 0.5;
		this._messageSprite.addChild(this._canvasContainer);

		this._canvasContainer.addChild(commonGame.createCanvasBg(common.levelConfig.gallery_select.frame.texture));

		// Trash fg sprite.
		this._trashFgSprite = new PIXI.Sprite(P3.assets.texture('icon_replay_fg'));
		this._trashFgSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._trashFgSprite.x = this._trashBgSprite.x;
		this._trashFgSprite.y = this._trashBgSprite.y;
		this._messageSprite.addChild(this._trashFgSprite);
	}

	show(message) {
		super.show(message);

		this._canvasContainer.y = this._messageText.y - 250;
		this._canvasContainer.alpha = 0;
		this._trashFgSprite.scale = new PIXI.Point(1, 1);
		this._trashBgSprite.scale = new PIXI.Point(1, 1);

		// TweenMax.to(this._canvasContainer, 1, {
		// 	y: this._trashBgSprite.y,
		// 	ease: Sine.easeOut,
		// 	repeat: -1,
		// 	repeatDelay: 0.5,
		// 	onRepeat: function () {
		// 		this._canvasContainer.alpha = 1;
		// 	},
		// 	onRepeatScope: this
		// });
		// TweenMax.to(this._canvasContainer, 0.5, {alpha: 0, ease: Sine.easeOut, repeat: -1, repeatDelay: 1, delay: 0.5});
		// TweenMax.fromTo(this._trashBgSprite.scale, 0.5, {x: 0.99, y: 0.99}, {
		// 	x: 1,
		// 	y: 1,
		// 	ease: Back.easeOut.config(100),
		// 	repeat: -1,
		// 	delay: 0.75,
		// 	repeatDelay: 1
		// });
		// TweenMax.fromTo(this._trashFgSprite.scale, 0.5, {x: 0.99, y: 0.99}, {
		// 	x: 1,
		// 	y: 1,
		// 	ease: Back.easeOut.config(100),
		// 	repeat: -1,
		// 	delay: 0.75,
		// 	repeatDelay: 1
		// });
	}

	destroy(options) {
		super.destroy();
	}

	update() {
		super.update();
	}
}
